<template>
  <div class="banner">
    <div class="tips flex justify-between">
      <div class="tips-left flex">
        <div class="tips-view">订单概览</div>
        <div @click="changeTab('WAIT_DELIVERY')" :class="['tab-item',{'active':activeDeliveryKey==='WAIT_DELIVERY'}]">待发货</div>
        <div @click="changeTab('WAIT_RECEIVE')" :class="['tab-item',{'active':activeDeliveryKey==='WAIT_RECEIVE'}]">待验收</div>
      </div>
      <div class="tips-more" @click="openManagerPage">更多 <RightOutlined /></div>
    </div>
    <div class="scroll-header flex">
        <div style="width: 112px;padding-left: 56px;">商品名称</div>
        <div style="width: 102px;padding-left: 56px;">单价</div>
        <div style="width: 70px;padding-left: 42px;">数量</div>
        <div style="width: 84px;padding-left: 36px;">总价</div>
        <div style="padding-left: 50px;">供应商</div>
    </div>
    <div class="scroll-inner-box">
        <vue3-seamless-scroll :list="orderList" class="scroll-banner" :hover="true" :step="1" :wheel="true" :singleHeight="50">
            <div class="scroll-cell flex" v-for="(item, index) in orderList" :key="index">
                <div class="scroll-left flex items-center">
                    <img class="w-38 h-38" style="border-radius: 14px;" :src="item.absoluteThumbnailUrl"/>
                    <div class="scroll-left-name">{{item.productName}}</div>
                </div>
                <div class="scroll-middle flex items-center pl-12"  style="width: 100px;">
                    <span class="price-value">{{utils.toFixed2(item.payableUnitPrice)}}</span>
                    <span class="price-unit">元/{{item.unitName}}</span>
                </div>
                <div class="scroll-middle flex items-center justify-center"  style="width: 70px;font-size:14px;">{{item.count}}</div>
                <div class="scroll-middle flex items-center pl-8" style="width: 100px;">
                    <span class="price-value" style="color:#FF2222">{{utils.toFixed2(item.payAmount)}}</span>
                    <span class="price-unit">元/{{item.unitName}}</span>
                </div>
                <div class="scroll-supplier" style="width: 82px;">{{item.supplierName}}</div>
            </div>
        </vue3-seamless-scroll>
    </div>
  </div>
  <div class="news">
    <div class="news-tips">财务概览</div>
    <div class="flex flex-wrap">
      <div class="cell-item flex justify-between items-center">
        <span class="cell-tip">今日订单金额</span>
        <span class="cell-price">¥{{utils.formattedOrderAmount(outLineData?.today?.payAmount)}}</span>
      </div>
      <div class="cell-item flex justify-between items-center">
        <span class="cell-tip">近3日订单金额</span>
        <span class="cell-price">¥{{utils.formattedOrderAmount(outLineData?.last3Days?.payAmount)}}</span>
      </div>
      <div class="cell-item flex justify-between items-center">
        <span class="cell-tip">近一周订单金额</span>
        <span class="cell-price">¥{{utils.formattedOrderAmount(outLineData?.week?.payAmount)}}</span>
      </div>
      <div class="cell-item flex justify-between items-center">
        <span class="cell-tip">近一月订单金额</span>
        <span class="cell-price">¥{{utils.formattedOrderAmount(outLineData?.month?.payAmount)}}</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
import { RightOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
const store = useStore();
const userInfo = computed(() => store.state.user.userInfo)  //ref(true)//;
const Token = computed(() => store.state.token?.token || '')
import api from '@/net/api'
import utils from "@/utils";
const activeDeliveryKey = ref("WAIT_DELIVERY");
const activeDeliveryList = ref([
  { key: "WAIT_DELIVERY", name: "待发货" },
  { key: "WAIT_RECEIVE", name: "待验收" },
]);
const orderList = ref([])
function changeTab(params) {
  activeDeliveryKey.value = params
  orderParams.value.state = params
  getOrderList()
}
// 跳转管理后台
function openManagerPage() {
  let url = ''
  switch (process.env.NODE_ENV) {
    case 'development':
      url = 'https://test.rongdaufun.com/'
      break
    case 'production':
      url = 'https://www.rongdajicai.com/'
      if (location.host == 'test.rongdaufun.com') {
        url = 'https://test.rongdaufun.com/'
      }
      break
    default:
      break
  }
  // window.open(url)
  // 创建一个iframe
  const iframe = document.createElement('iframe')
  iframe.style.height = '0'
  iframe.style.border = 'none'
  // 先跳转到 switch-region.html 中转页，将 token 等信息带到新域名
  iframe.src = url+`spa/switch-region.html?Token=`+Token.value

  document.body.appendChild(iframe)

  // iframe加载，表示token已经写入到新域名中
  // 跳转到 ng 站点
  iframe.onload = () => {
    let timer = setTimeout(() => {
      // window.location.href = 'https://www.rongdajicai.com/sc-manager/#/main/order/list'
      window.open('https://www.rongdajicai.com/sc-manager/#/main/order/list')
      clearTimeout(timer)
    }, 1000)
  }

}
  // 订单获取列表
  const orderParams = ref({
    currentPage: 1,
    pageSize: 20,
    includeStoreToWarehouse: true,
    productName: null,
    state: 'WAIT_DELIVERY'
  })

function getOrderList(){
  api.buyer_order_list(orderParams.value).then(res=>{
    orderList.value = res.list
  })
}
// 获取财务概览
const outLineData = ref({})
function getOutLine(){
  api.buyer_order_plat_outline().then(res=>{
    outLineData.value = res
  })
}
onMounted(()=>{
  getOrderList()
  getOutLine()
})
</script>
<style lang="scss" scoped>
.banner {
    width: 580px;
    height: 254px;
    background: linear-gradient(179deg, #C1E5D5 0%, #DBF2EB 100%);
    border-radius: 10px;
    padding:14px;
  .tips {
    .tips-left {
      .tips-view {
        margin-right:10px;
        font-size: 16px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        color: #004024;
      }
      .tab-item {
        font-size: 15px;
        font-family: MicrosoftYaHei;
        color: #6b9d87;
        width:70px;
        line-height:23px;
        text-align:center;
        cursor: pointer;
        margin-top: -3px;
        &.active {
          font-weight: bold;
          color: #00876a;
          position: relative;
          &::before {
            position: absolute;
            content: "";
            dispaly: block;
            width: 50px;
            height: 2px;
            background: #009172;
            bottom: -3px;
            left: 10px;
          }
        }
      }
    }
    .tips-more{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #74A38F;
        cursor: pointer;
        font-weight: 400;
    }
  }
  .scroll-header {
        width: 552px;
        height: 50px;
        background: #ffffff;
        line-height: 50px;
        border-radius: 12px;
        font-size: 14px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        color: #333333;
        margin-bottom: 6px;
        text-align: left;
        margin-top:18px;
    }
  .scroll-inner-box {
        width: 100%;
        height: 143px;
        overflow: hidden;

        .scroll-cell {
            width: 100%;
            height: 50px;
            background: rgba(255, 255, 255, 0.7);
            margin-bottom: 6px;
            border-radius: 14px;

            .scroll-left {
                width: 134px;
                padding-left: 6px;

                .scroll-left-name {
                    width: 90px;
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: left;
                    padding-left: 12px;
                }
            }

            .scroll-middle {
                width: 130px;
            }

            .price-value {
                font-size: 14px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                color: #333333;
                vertical-align: text-bottom;
            }

            .price-unit {
                font-size: 12px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                color: #666666;
                vertical-align: text-bottom;
            }
            .scroll-supplier{
                width:70px;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #333333; 
                display:flex;
                align-items:center;
            }
        }
    }
}

.news {
  width: 580px;
  height: 140px;
  background: linear-gradient(180deg, #F9DBDD 0%, #FCE9EA 100%);
  border-radius: 10px;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  margin-top: 10px;

  .news-tips {
    font-size: 16px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    color: #521F23;
    margin-bottom: 9px;
  }
    .cell-item{
        width: 271px;
        height: 34px;
        background: #FFFFFF;
        border-radius: 4px;
        box-sizing:border-box;
        padding:0 10px;
        &:nth-child(n+3){
            margin-top:10px;
        }
        &:nth-child(2n){
            margin-left:8px;
        }
        .cell-tip{
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: #333333;
        }
        .cell-price{
            font-size: 14px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            color: #FF2222;
        }
    }
}
</style>
